import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage, useIntl, defineMessages } from "react-intl";
import moment from "moment-timezone";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import Grid from "@material-ui/core/Grid";
import Collapse from "@material-ui/core/Collapse";
import CompletionCode from "../../admin/completionCodePopup";
import { fetchAttachments } from "../../../redux/attachments/attachmentsActions";
import { fetchVendorManager, fetchWorkorder, taskComplete } from "../../../redux/task/taskActions";
import { requestCompleteReasons } from "../../../redux/reason/reasonActions";
import { fetchBillingComments } from "../../../redux/billing/billingActions";
import { Card } from "../../common/card/card";
import MainHeader from "../../header/mainHeader";
import Actions from "../../header/headerActions/actions";
import WorkOrderList from "../../header/headerActions/workOrderList";
import { useLocalizedName, getlabourerTaskStatus, getLocalizedNameWithIntl } from "../../../globals/langHelpers";
import PhoneIcon from "../../common/icons/phoneIcon";
import { phoneNumberFormatterValue } from "../../common/dataList/dataListHelper";
import { Caption, Value, CardTitle } from "../../admin/workOrderDetails";
import { useWorkOrderStyles } from "./workOrderStyles";
import Attachments from "./attachments";
import WorkOrderActivity from "./workOrderActivity";
import "./workorderdetails.css";
import Comments from "./comments";
import { WORKTYPES } from "../../../globals/workTypes";
import WorkOrderAssignementInfo from "../../admin/workOrderAssignementInfo";

const messages = defineMessages({
    yesResponse: {
        id: "tech.wo-details.yes-response",
        defaultMessage: "Yes",
        description: "Respond yes to question asked",
    },
    noResponse: {
        id: "tech.wo-details.no-response",
        defaultMessage: "No",
        description: "Respond no to question asked",
    },
    details: {
        id: "tech.wo-details.details-subheader-caption",
        defaultMessage: "Details",
        description: "Details subheader",
    },
});

const WorkOrderDetails = (props, workOrderData, assignmentInformation) => {
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();
    const history = useHistory();
    const { vendorManager, workorderData, comments } = props;
    const { workOrderNumber } = useParams();
    const [customerCollapse, setCustomerCollapse] = useState(true);
    const [workDetailsCollapse, setWorkDetailsCollapse] = useState(true);
    const [assignmentInformationCollapse, setAssignmentInformationCollapse] = useState(true);
    const [showCompletionModal, setShowCompletionModal] = React.useState(false);
    const classes = useWorkOrderStyles();
    let workOrderDets = {};
    let workorderInfo = {};
    let activityQuestions = [];
    let ticketCreationInfo = {};
    let plantTypeDetails = {};
    let multipleWorkActivity = [];
    const vendorManagerReady = vendorManager ? !(Object.keys(vendorManager).length === 0) : false;
    useEffect(() => {
        if (Object.keys(workorderData).length !== 0)
            props.fetchVendorManager(
                workorderData.zone ? workorderData.zone.replace("C_", "") : null,
                workorderData.workActivity.id ? workorderData.workActivity.id : null,
            );
    }, [workorderData]);

    useEffect(() => {
        if (workOrderNumber) {
            props.fetchWorkorder(workOrderNumber);
            props.fetchAttachments(workOrderNumber);
            props.fetchBillingComments(workOrderNumber);
            props.requestCompleteReasons();
        }
    }, [workOrderNumber]);

    if (!workOrderDets) {
        return null;
    }

    if (props.workorderInfo.workorderData !== undefined && props.workorderInfo.workorderData.workOrderNumber === workOrderNumber) {
        workOrderDets = props.workorderInfo.workorderData;
        workorderInfo = props.workorderInfo.workorderInfo;
        assignmentInformation = props.assignmentInfo;
        ticketCreationInfo = workOrderDets.workOrderDetail.technicianDetails;
        multipleWorkActivity = props.workorderInfo?.multipleWorkActivityInformation?.body;
    }
    const customerToggle = () => {
        setCustomerCollapse((prev) => !prev);
    };

    const workDetailsToggle = () => {
        setWorkDetailsCollapse((prev) => !prev);
    };

    const assignmentInfoToggle = () => {
        setAssignmentInformationCollapse((prev) => !prev);
    };

    const getFormattedDate = (assignDate, separator = "/") => {
        if (assignDate === null || assignDate === undefined) return "";

        return moment(assignDate).format("MMM DD, YYYY");
    };

    const getTimeRange = (idate, duration) => {
        if (idate === "" || idate === undefined || duration === "" || duration === undefined) {
            return "";
        }
        const date = idate._isAMomentObject ? idate : moment(Date.parse(idate.slice(0, 19)));
        let formatedString = date.format("LT");
        return formatedString + " - " + date.add(duration, "seconds").format("LT");
    };

    const completeTask = (val, completionDate) => {
        props.taskComplete({
            workOrderNumber: workOrderNumber,
            userName: props?.userInfo?.preferred_username,
            completionCode: +val,
            completionDate: completionDate,
        });
        history.push(`/workorderdetails/${workorderData.workOrderNumber}/complete`);
    };
    return (
        <div>
            <div className="main-header">
                <MainHeader subtitle="CMIS" actions={[<WorkOrderList />, <Actions jobActions onComplete={() => setShowCompletionModal(true)} />]} />
                <Grid container className="card-header">
                    <Grid className="card-header-right">
                        <Grid className="innr-1">
                            <Grid id="wo">
                                WO&#35;&nbsp;
                                <Grid id="wo-number">{workOrderNumber}</Grid>
                            </Grid>
                            <Grid className="phone-assign-position">
                                {phoneNumberFormatterValue(workOrderDets.phoneNumber)} &nbsp;
                                <Grid className="assigned">{getlabourerTaskStatus(intl, workOrderDets.status)}</Grid>
                            </Grid>
                        </Grid>
                        <Grid className="card-header-cross"></Grid>
                        <Grid className="card-header-phoneno">
                            <Grid id="date">{getFormattedDate(workOrderDets?.scheduledDate)}</Grid>
                            <Grid id="time">
                                {workOrderDets?.scheduledDate
                                    ? getTimeRange(moment.tz(workOrderDets?.scheduledDate, moment.tz.guess()), workOrderDets?.duration)
                                    : null}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            {workOrderDets.workType && workOrderDets.workType.displayCustomerInfo && (
                <div className="customer-location">
                    <div className="cust-hdr" onClick={customerToggle}>
                        <FormattedMessage
                            id="tech.wo-details.customer-location-caption"
                            defaultMessage="Customer \u0026 Location"
                            description="Technicians work order details customer location caption"
                        />
                    </div>
                    <Collapse in={customerCollapse}>
                        <Card className="card">
                            <Grid container className={classes.row}>
                                <Grid item xs={9} md={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.customer-name-caption"
                                            defaultMessage="Customer name"
                                            description="Technicians work order details customer name caption"
                                        />
                                    </Caption>
                                    <Value>{workorderInfo?.customerName}</Value>
                                    <div className="phone-icon">
                                        <PhoneIcon className="phone-icon-svg" />
                                    </div>
                                </Grid>
                                <Grid item xs={9} md={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.preferred-phone-number-caption"
                                            defaultMessage="Preferred phone number"
                                            description="Technicians work order details preferred phone number caption"
                                        />
                                    </Caption>
                                    <Value>{phoneNumberFormatterValue(workorderInfo?.PreferredContact)}</Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={9}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.customer.customer-phone-caption"
                                            defaultMessage="Customer phone #"
                                            description="Admin work order Customer phone # caption"
                                        />
                                    </Caption>
                                    <Value>{phoneNumberFormatterValue(workorderInfo?.customerPhoneNumber)}</Value>
                                </Grid>
                            </Grid>
                        </Card>
                        <Card>
                            <Grid container className={classes.row}>
                                <Grid item xs={9}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.customer.location-caption"
                                            defaultMessage="Customer Location"
                                            description="Technicians work order details location caption"
                                        />
                                    </Caption>
                                    {/* <Value></Value> */}
                                    {/* , {workorderInfo.province} was originall after municipality, but it was removed from DB*/}
                                    <Value>
                                        {workorderInfo.unitNumber && (
                                            <span>
                                                {workorderInfo.unitNumber} <br />
                                            </span>
                                        )}
                                        <span>
                                            {workorderInfo.civicAddress} {workorderInfo.locationStreet} <br />
                                            {workorderInfo.municipality} <br />
                                            {workorderInfo.postalCode}
                                        </span>
                                    </Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={9}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.location-caption"
                                            defaultMessage="Work Location"
                                            description="Technicians work order details location caption"
                                        />
                                    </Caption>
                                    {/* <Value></Value> */}
                                    {/* , {workorderInfo.province} was originall after municipality, but it was removed from DB*/}
                                    <Value>
                                        {(workOrderDets.addressUnit || workOrderDets.apartmentFloor) && (
                                            <span>
                                                {workOrderDets.addressUnit} {workOrderDets.apartmentFloor} <br />
                                            </span>
                                        )}
                                        <span>
                                            {workOrderDets.civicNumber} {workOrderDets.streetName} <br />
                                            {workOrderDets.municipality} <br />
                                            {workOrderDets.postalCode}
                                        </span>
                                    </Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.intersection-1-caption"
                                            defaultMessage="Intersection 1"
                                            description="Technicians work order details intersection 1 caption"
                                        />
                                    </Caption>
                                    <Value>{workorderInfo?.intersection1}</Value>
                                </Grid>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.intersection-2-caption"
                                            defaultMessage="Intersection 2"
                                            description="Technicians work order details intersection 2 caption"
                                        />
                                    </Caption>
                                    <Value>{workorderInfo?.intersection2}</Value>
                                </Grid>
                            </Grid>
                            <Grid container className={classes.row}>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.central-office-caption"
                                            defaultMessage="Central Office"
                                            description="Central Office column label"
                                        />
                                    </Caption>
                                    <Value>{workOrderDets.centralOffice ? workOrderDets.centralOffice.name : ""}</Value>
                                </Grid>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.clli-code-caption"
                                            defaultMessage="CLLI"
                                            description="Technicians work order details CLLI code caption"
                                        />
                                    </Caption>
                                    <Value>{workOrderDets.zone}</Value>
                                </Grid>
                            </Grid>
                        </Card>
                        {ticketCreationInfo && (
                            <>
                                <div>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.ticket-creation-title"
                                        defaultMessage="Ticket creation information"
                                        description="Technicians work order details Ticket creation information header"
                                    />
                                </div>
                                <Card>
                                    <Grid container className={classes.row}>
                                        <Grid item xs={6}>
                                            <Caption>
                                                <FormattedMessage
                                                    id="admin.work-order-details.wo-info.ticket-created-by-caption"
                                                    defaultMessage="Created by"
                                                    description="Technicians work order Created by caption"
                                                />
                                            </Caption>
                                            <Value>{ticketCreationInfo.firstName + " " + ticketCreationInfo.lastName}</Value>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Caption>
                                                <FormattedMessage
                                                    id="admin.work-order-details.wo-info.ticket-pein-caption"
                                                    defaultMessage="PEIN"
                                                    description="Technicians work order creation PEIN caption"
                                                />
                                            </Caption>
                                            <Value>{ticketCreationInfo.employeeID}</Value>
                                        </Grid>
                                    </Grid>

                                    <Grid container className={classes.row}>
                                        <Grid item xs={6}>
                                            <Caption>
                                                <FormattedMessage
                                                    id="admin.work-order-details.wo-info.ticket-creation-company-caption"
                                                    defaultMessage="Company"
                                                    description="Technicians work order creation company caption"
                                                />
                                            </Caption>
                                            <Value>{ticketCreationInfo.company}</Value>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Caption>
                                                <FormattedMessage
                                                    id="admin.work-order-details.wo-info.ticket-mobile-number-caption"
                                                    defaultMessage="Mobile number"
                                                    description="Technicians work order creation mobile number caption"
                                                />
                                            </Caption>
                                            <Value>{ticketCreationInfo.mobileNumber}</Value>
                                        </Grid>
                                    </Grid>

                                    <Grid container className={classes.row}>
                                        <Grid item xs={12}>
                                            <Caption>
                                                <FormattedMessage
                                                    id="admin.work-order-details.wo-info.ticket-email-caption"
                                                    defaultMessage="Email"
                                                    description="Technicians work order creation email caption"
                                                />
                                            </Caption>
                                            <Value>{ticketCreationInfo.email}</Value>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </>
                        )}

                        <div>
                            <FormattedMessage
                                id="admin.work-order-details.wo-info.click-info-title"
                                defaultMessage="Other information"
                                description="Technicians work order details other information header"
                            />
                        </div>
                        {process.env.REACT_APP_FEATURE_CMISR3 === "true" && (
                            <Card>
                                <Grid container className={classes.row}>
                                    <Grid item xs={6}>
                                        <Caption>
                                            <FormattedMessage
                                                id="admin.work-order-details.wo-info.click.vendor-manger-caption"
                                                defaultMessage="vendor manager"
                                                description="Technicians work order details vendor manager caption"
                                            />
                                        </Caption>
                                        <Value>{vendorManagerReady ? `${vendorManager.firstName} ${vendorManager.lastName}` : ""}</Value>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Caption>
                                            <FormattedMessage
                                                id="admin.work-order-details.wo-info.click.vendor-manger-phone-number-caption"
                                                defaultMessage="vendor manager phone number"
                                                description="Technicians work order details vendor manager phone number caption"
                                            />
                                        </Caption>
                                        <Value>{vendorManagerReady ? vendorManager.phoneNumber : ""}</Value>
                                    </Grid>
                                </Grid>
                                <Grid container className={classes.row}>
                                    <Grid item xs={6}>
                                        <Caption>
                                            <FormattedMessage
                                                id="admin.work-order-details.wo-info.click.vendor-manger-email-caption"
                                                defaultMessage="vendor manager email"
                                                description="Technicians work order details vendor manager email caption"
                                            />
                                        </Caption>
                                        <Value>{vendorManagerReady ? vendorManager.email : ""}</Value>
                                    </Grid>
                                </Grid>
                            </Card>
                        )}
                    </Collapse>
                </div>
            )}

            <div className="work-details">
                <div className="work-hdr" onClick={assignmentInfoToggle}>
                    <FormattedMessage
                        id="admin.work-order-details.wo-info.assignment-info-title"
                        defaultMessage="Assignment information"
                        description="Admin Assignment information title"
                    />
                </div>
                <Collapse in={assignmentInformationCollapse}>
                    <WorkOrderAssignementInfo
                        customerPhoneNumber={workorderInfo?.accessId ? workorderInfo?.accessId : workorderInfo?.customerPhoneNumber}
                        isAdmin={false}
                        assignmentInformation={assignmentInformation}
                    />
                </Collapse>
            </div>

            <div className="work-details">
                <div className="work-hdr" onClick={workDetailsToggle}>
                    <FormattedMessage
                        id="tech.wo-details.work-details-activities-caption"
                        defaultMessage="Work details \u0026 activities"
                        description="Technicians work order details and activities caption"
                    />
                </div>
                <Collapse in={workDetailsCollapse}>
                    <Card className="card">
                        <CardTitle style={{ marginLeft: "8px" }}>
                            {/* Reusing admin text */}
                            <FormattedMessage
                                id="admin.work-order-details.wo-info.work-details-title"
                                defaultMessage="Work details"
                                description="Admin work order work details title"
                            />
                        </CardTitle>

                        <Grid container className={classes.row}>
                            <Grid item xs={9}>
                                <Caption>
                                    <FormattedMessage
                                        id="tech.wo-details.parent-job-classification-caption"
                                        defaultMessage="Parent job classification"
                                        description="Technicians work order details parent job classification caption"
                                    />
                                </Caption>
                                <Value>{getLocalizedName({ object: workorderInfo?.jobClassification })}</Value> <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Caption>
                                    <FormattedMessage
                                        id="tech.wo-details.priority-caption"
                                        defaultMessage="Priority"
                                        description="Technicians work order details priority"
                                    />
                                </Caption>
                                <Value>{getLocalizedName({ object: workOrderDets.priority }).split(" ")[0]}</Value> <br />
                            </Grid>

                            <Grid item xs={6}>
                                <Caption>
                                    <FormattedMessage
                                        id="tech.wo-details.reason-for-work-order-caption"
                                        defaultMessage="Reason for work order"
                                        description="Technicians work order details reason for work order caption"
                                    />
                                </Caption>
                                <Value>{getLocalizedName({ object: workorderInfo?.workOrderReason })}</Value>
                            </Grid>
                        </Grid>

                        {workOrderDets.FK_workType === WORKTYPES.MH_WORK && (
                            <Grid container className={classes.row}>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="admin.work-order-details.wo-info.cs-entry-num-caption"
                                            defaultMessage="CS entry number"
                                            description="Admin work order CS entry number caption"
                                        />
                                    </Caption>
                                    <Value>{workOrderDets.workOrderDetail.confinedSpaceNumber}</Value>
                                </Grid>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.manhole-route-caption"
                                            defaultMessage="Manhole route"
                                            description="Technicians work order details manhole route caption"
                                        />
                                    </Caption>
                                    <Value>{workorderInfo.manHoleIdentifierRoute}</Value>
                                    <br />
                                </Grid>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.cs-number-caption"
                                            defaultMessage="CS number"
                                            description="Technicians work order details CS number caption"
                                        />
                                    </Caption>
                                    <Value>{workorderInfo.manHoleIdentifierId}</Value>
                                </Grid>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.cs-type-caption"
                                            defaultMessage="CS type"
                                            description="Technicians work order details CS type caption"
                                        />
                                    </Caption>
                                    <Value>{getLocalizedName({ object: workorderInfo.csType })}</Value>
                                    <br />
                                </Grid>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.street-caption"
                                            defaultMessage="Street"
                                            description="Technicians work order details street caption"
                                        />
                                    </Caption>
                                    <Value>{workorderInfo.streetName}</Value>
                                </Grid>

                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.cross-street-caption"
                                            defaultMessage="Cross street"
                                            description="Technicians work order details cross street caption"
                                        />
                                    </Caption>
                                    <Value>{workorderInfo.crossStreet}</Value>
                                    <br />
                                </Grid>

                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.manhole-contaminated-caption"
                                            defaultMessage="Manhole contaminated"
                                            description="Technicians work order details manhole contaminated caption"
                                        />
                                    </Caption>
                                    <Value>
                                        {workorderInfo.manholeContaminated
                                            ? intl.formatMessage(messages.yesResponse)
                                            : intl.formatMessage(messages.noResponse)}
                                    </Value>
                                    <br />
                                </Grid>
                            </Grid>
                        )}

                        {workOrderDets.FK_workType === WORKTYPES.MISCELLANEOUS && <Grid container className={classes.row}></Grid>}

                        {(workOrderDets.FK_workType === WORKTYPES.AERIAL_WORK || workOrderDets.FK_workType === WORKTYPES.BURIED_WORK) && (
                            <Grid container className={classes.row}>
                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.network-type-caption"
                                            defaultMessage="Network type"
                                            description="Technicians work order details network type caption"
                                        />
                                    </Caption>
                                    <Value>{workorderInfo.networkType}</Value>
                                </Grid>

                                <Grid item xs={6}>
                                    <Caption>
                                        <FormattedMessage
                                            id="tech.wo-details.plant-type-caption"
                                            defaultMessage="Plant type"
                                            description="Technicians work order details plant type caption"
                                        />
                                    </Caption>
                                    <Value>{getLocalizedName({ object: workOrderDets?.workOrderDetail?.plantTypeDetails })}</Value> <br />
                                </Grid>
                            </Grid>
                        )}
                    </Card>{" "}
                    {/* Will eventually show multiple */}
                    {multipleWorkActivity !== null &&
                        typeof multipleWorkActivity !== "string" &&
                        multipleWorkActivity?.map((WorkActivitydetails, i) => {
                            return (
                                <WorkOrderActivity
                                    key={WorkActivitydetails.id || i}
                                    count={i + 1}
                                    index={i}
                                    WorkActivitydetails={WorkActivitydetails}
                                />
                            );
                        })}
                    <Comments comments={comments} workorderInfo={workorderInfo} />
                    <div>
                        <FormattedMessage
                            id="tech.wo-details.attachments-header"
                            defaultMessage="Attachments"
                            description="Technicians work order details Attachments header"
                        />
                    </div>
                    <Card>
                        <Grid container>
                            <Grid item className={classes.rowFull}>
                                <Attachments
                                    workOrderAttachments={props.workOrderAttachments}
                                    clickDispatchId={workOrderDets.clickDispatchId}
                                    workOrderNumber={workOrderNumber}
                                    workOrderStatus={workOrderDets.status}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                </Collapse>
            </div>
            {showCompletionModal && (
                <CompletionCode
                    showCompletionModal
                    dueDate={workorderData?.originalDueDate}
                    workOrderNumber={workorderData?.workOrderNumber}
                    setShowCompletionModal={setShowCompletionModal}
                    onCompletionCallback={completeTask}
                    workorderData={workorderData}
                    CmisLabourer
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        vendorManager: state.tasks.vendorManagerByOrder,
        technicianInfo: state.login.technicianInfo,
        workorderInfo: state.tasks.workorderData,
        workorderData: state.tasks.workorderData.workorderData,
        workOrderAttachments: state.attachments.workOrderAttachments,
        assignmentInfo: state.tasks.assignmentInformation,
        userInfo: state.login.userInfo,
        comments: state.billing.comments,
        login: state.login,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchVendorManager,
            fetchWorkorder,
            fetchAttachments,
            taskComplete,
            fetchBillingComments,
            requestCompleteReasons,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderDetails);
